import i18n from '../../../../i18n'
import { TableCellButton, TableTextCell } from '../../../Table'
import { isEmailCorporate, isEmailShared } from '../../Email.utils'
import { EMAIL_RECONNECT_ACCOUNTS_TABLE_CELL_NAME } from '../EmailReconnectAccountsModal.constants'

function getTypeTitle(item) {
  if (isEmailShared(item)) {
    return i18n.t('Email.ReconnectAccountSharedTypeKey')
  }

  if (isEmailCorporate(item)) {
    return i18n.t('Email.ReconnectAccountCorporateTypeKey')
  }

  return i18n.t('Email.ReconnectAccountPrivateTypeKey')
}

export function renderCell({ item, name, ...restProps }) {
  switch (name) {
    case EMAIL_RECONNECT_ACCOUNTS_TABLE_CELL_NAME.account:
      return <TableTextCell {...restProps} value={item.email} />
    case EMAIL_RECONNECT_ACCOUNTS_TABLE_CELL_NAME.type:
      return <TableTextCell {...restProps} value={getTypeTitle(item)} />
    case EMAIL_RECONNECT_ACCOUNTS_TABLE_CELL_NAME.action:
      return (
        <TableCellButton
          {...restProps}
          buttonProps={{
            isActive: true,
            text: i18n.t('Email.ReconnectAccountBtnKey'),
          }}
          id={item.id}
        />
      )
  }
}
